import React, { useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  styled,
  Typography,
} from "@mui/material";

const CustomLabel = styled(FormControlLabel)({
  flex: "1 0 25%",
  margin: " 0 0",
  padding: "8px 0 6px 10px",
  "&:hover": {
    backgroundColor: "#FFFBFC",
  },
  "&:nth-of-type(2), :nth-of-type(3), :nth-of-type(4)": {
    borderLeft: "2px solid #D6D6DB",
  },
  "& .MuiRadio-root": {
    color: "#667085",
  },
  "& .MuiTypography-root": {
    fontSize: "16px",
    color: "#4F4F4F",
  },
  "& .MuiRadio-root:hover": {
    backgroundColor: "transparent",
  },
  "& .Mui-checked ": {
    color: "#F56193",
  },
});

interface CustomRadioButtonProps {
  sx?: any;
  value: string;
  label: string;
  onInputValueChange: (newValue: string) => void;
}

export const CustomRadioButton = ({
  sx,
  value,
  label,
  onInputValueChange,
}: CustomRadioButtonProps) => {
  const [selectedValue, setSelectedValue] = useState<string>(value);

  const handleChangeValue = (e: any) => {
    setSelectedValue(e.target.value);
    onInputValueChange(e.target.value);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #D6D6DB",
        flex: 1,
        ...sx,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#F3F3F3",
          color: "#1F1F1F",
          padding: "16px",
          minWidth: 192,
          borderTopLeftRadius: sx?.borderTopLeftRadius,
          borderBottomLeftRadius: sx?.borderBottomLeftRadius,
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flex: 1,
        }}
      >
        <FormControl
          sx={{
            flex: 1,
          }}
        >
          <RadioGroup
            sx={{
              flexWrap: "nowrap",
            }}
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <CustomLabel
              checked={selectedValue === "none"}
              value="none"
              control={<Radio disableRipple />}
              label="No Rank"
              onChange={handleChangeValue}
            />
            <CustomLabel
              checked={selectedValue === "junior"}
              value="junior"
              control={<Radio disableRipple />}
              label="Junior"
              onChange={handleChangeValue}
            />
            <CustomLabel
              checked={selectedValue === "master"}
              value="master"
              control={<Radio disableRipple />}
              label="Master"
              onChange={handleChangeValue}
            />
            <CustomLabel
              checked={selectedValue === "top"}
              value="top"
              control={<Radio disableRipple />}
              label="Top"
              onChange={handleChangeValue}
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
};
